import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { CrumpType } from '@wajeez-web/core/types';
import { useBusinessSelector } from '@wajeez-web/stores/business-group';

export const BusinessCrump: CrumpType = ({ params }): JSX.Element => {
  const id = params['id'];
  const { detailsHistory } = useBusinessSelector((s) => s.businessGroups);

  return (
    <ReturnTranslatedText
      text={`breadCrumbs.${detailsHistory.find((s) => s.id == id)?.name}`}
      origintext={detailsHistory.find((s) => s.id == id)?.name}
    />
  );
};
